import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as TipoParticipantes from '../../constantes/TipoParticipacionTorneo.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import MensajeError from '../../UI/MensajeError.js';

const ListaTiposTorneoOrganizador = (props) => {
  const organizador = props.organizador;
  const styles = props.styles;
  const [listaTiposTorneo, setListaTiposTorneo] = useState([]);
  const { erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (organizador) {
      fetchData(
        'tipos_torneo?oficialidad=' +
          organizador.oficialidad +
          '&tipoParticipacion=' +
          TipoParticipantes.SELECCIONES,
        setListaTiposTorneo
      );
    } else {
      setListaTiposTorneo([]);
    }
  }, [organizador, fetchData]);

  return (
    <React.Fragment>
      {listaTiposTorneo && listaTiposTorneo.length > 0 && (
        <React.Fragment>
          {listaTiposTorneo.map((tipoTorneo, index) => (
            <tr key={index} className={`${styles.fila}`}>
              <td className={`${styles.tipoTorneo}`} data-label="Torneo">
                <Link to={'/torneosInt/' + tipoTorneo.codigo}>{tipoTorneo.nombre}</Link>
              </td>
            </tr>
          ))}
          <MensajeError errores={erroresGetLista} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ListaTiposTorneoOrganizador;
